// DEPENDENCIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {clearAllBodyScrollLocks, disableBodyScroll} from "body-scroll-lock";

import Modal from 'react-modal';
import { connect } from 'react-redux';
import ScrollArea from 'react-scrollbar';
import { browserHistory } from 'react-router';
import SVGInline from "react-svg-inline"

// INNER IMPORTS
import {isMobile, makeLinkFromString} from '../../utils';
import { BAND, SERVICE, MUSICIAN, LIVE_MUSIC } from '../../consts';
import {AnalyticsService} from "../../Services";

import BandFinderForm from './Submit/BandFinderForm';
import MediaBandFinderLinks from './Submit/MediaBandFinderLinks';

import * as userActions from '../../Actions/users';
import { setWarningMessage } from "../../Actions/messages";
import {
    openPayingMethodsModal,
    openGeneralMessageModal,
    getPinsCall,
    getMapPinsCall,
    openLoadingModal
} from '../../Actions/main';
import {
    youtube_parser,
    vimeo_parser,
    isEmailValid,
    isPhoneNumberValid,
    isFBPageUrlValid,
    capitalize
} from '../../utils';
import { ContactBandFinder } from '../Elements/Inputs';
import { BandFinderTypePicker } from '../Elements/Pickers';
import { BandFinderSlider } from '../Elements/Carousels';


// svgs
import lightningSvg from '../inlineSVGs/lightningSVG';

import scopWhiteTxtSVG from '../inlineSVGs/scopWhiteTxtSVG';
import backgroundDotsSVG from '../inlineSVGs/backgroundDotsSVG';
import closeCrossSVG from '../inlineSVGs/closeCrossSVG';


// style
import './SubmitBandFinderModal.css';
import {translateMissingItem} from "../../lang";

const MAX_TITLE_CHARS = 50;
const LOOKING_FOR_LIMIT = 15;

class SubmitBandFinderModal extends Component {
    constructor(props) {
        super(props);

        this.state = { userShouldEnter: [] };
    }

    stopMobilePropagation(event) {
        event.stopPropagation();
    }

    componentDidMount() {
        if (isMobile()) {
            document.body.addEventListener("touchmove", this.stopMobilePropagation, { passive: false });
        }
    }

    // for now only on submit
    handleClickAnywhere() {
        // if (!this.props || this.props.token) return;
        //
        // setTimeout(() => {
        //     this.props.openSignupModal({
        //         signupTextType: 'member-notice'
        //     })
        // }, 200);
    }

    componentWillUnmount() {
        if (isMobile()) {
            document.body.remove("touchmove", this.stopMobilePropagation);
        }
    }

    componentWillReceiveProps(nextProps) {
        if ((!this.state.loadedPinId ||(this.state.loadedPinId !== (nextProps.editPinData || {}).id)) && Object.keys(nextProps.pinDataWaiting || {}).length < 1) {
            this.setState({loadedPinId: (nextProps.editPinData || {})._id});
            if (nextProps.editMode) {
                const editPinData = nextProps.editPinData;

                this.setState({
                    iWeAre: { singular: editPinData.iWeAre },
                    priceFinal: (editPinData.prices && editPinData.prices.price) || 0,
                    priceRangeMin: (editPinData.prices && editPinData.prices.min) || 0,
                    priceRangeMax: (editPinData.prices && editPinData.prices.max) || 0,
                    priceSelected: (editPinData.prices && editPinData.prices.priceType) || 'free',
                    selectedCurrency: (editPinData.prices && editPinData.prices.currency) || 'ILS',
                    images: editPinData.images && editPinData.images.length > 0 ? editPinData.images : [],
                    files: editPinData.files && editPinData.files.length > 0 ? editPinData.files : [],
                    ...editPinData
                });
            } else {
                // reset only on open and close modal - non edit mode
                if ((!this.props.isModalOpen && (nextProps.isModalOpen || (this.props.isModalOpen && !nextProps.isModalOpen)))) {
                    // this use to assigned to 'state' directly in the pass... reason was to reset modal after closing
                    this.stateReset(nextProps);
                    // if (this.props && !this.props.token) {
                    //     setTimeout(() => {
                    //         this.props.openSignupModal({
                    //             signupTextType: 'member-notice'
                    //         });
                    //     }, 1200)
                    // }
                }
            }
        }

        if (!this.props.isModalOpen && nextProps.isModalOpen) {
            setTimeout(() => {
                disableBodyScroll(document.body);
            }, 200)

            if (!this.props.user || !this.props.user.myPins || this.props.user.myPins.length < 1) {
                this.props.getUserPins();
            }

        } else if (this.props.isModalOpen && !nextProps.isModalOpen) {
            // window.document.body.style.overflow = 'initial';
            clearAllBodyScrollLocks();
        }
    }

    stateReset(props) {
        this.setState({
            _id: '',
            id: '',
            type: '',
            iWeAre: '',
            images: [],
            files: [], // props.files,
            desc: '',
            category: props.type === LIVE_MUSIC ? 'openmic' : (props.type === SERVICE ? 'rehearsalrooms' : ''),
            location: '',
            price: 0,
            userShouldEnter: [],
            subCategories: [],
            priceFinal: 0,
            priceRangeMin: 0,
            priceRangeMax: 0,
            priceSelected: 'free',
            selectedCurrency: 'ILS',
            name: '',
            fblink: '',
            contactInfo: '',
            email: '',
            phone: '',
            date: '',
            time: 75600,
            lookingForTypes: [],
            video: '',
            video_embed: '',
            ticketLink: '',
            link1: '',
            link2: '',
        })
    }

    // Every time the user changes the email/password field, the state changes accordingly
    updateValue(event) {
        if (event.target.name === 'name' && event.target.value && event.target.value.length > MAX_TITLE_CHARS) return;

        this.setState({
            [event.target.name]: event.target.value
        });
    }

    updateDate(date) {
        this.setState({date});
    }

    updateTime(time) {
        this.setState({time});
    }

    setPrice(value) {
        this.setState({price: value})
    }

    updateLocation(place) {
        if (!place  || !place.geometry || !place.geometry.location) return;

        let location = {
            position: {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            }
        };

        place.address_components.forEach(c => {
            location[c.types[0]] = c.long_name;
        });
        this.setState({
            location: {
                position: {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                },
                state: location.administrative_area_level_1 || location.country,
                country: location.country,
                city: location.locality,
                street: location.route,
                number: parseInt(location.street_number, 10)
            }
        });
    }

    updateLocationValue(){
        if (this.props.editPinData) {
            let location = this.props.editPinData.location;
            document.getElementById("autocomplete").value = (location.street || '') + (location.number ? (" " + location.number + ", "): " ") + location.city + ", " + location.country;
        }
    }

    handleCategoryClick(selectObj) {
        let lookingForTypes = this.state.lookingForTypes || [];

        // select
        if (lookingForTypes.indexOf(selectObj.name) === -1 && lookingForTypes.length < LOOKING_FOR_LIMIT) {
            // lookingForTypes.push(selectObj.name);
            this.setState({ lookingForTypes: [...lookingForTypes, selectObj.name] });

            return;
        }

        if (lookingForTypes.indexOf(selectObj.name) !== -1) {
            lookingForTypes.splice(this.state.lookingForTypes.indexOf(selectObj.name), 1);
            // deselect
            this.setState({ lookingForTypes:  lookingForTypes });
            return;
        }

        // if limit reached pop up warning message and dont add category
        // 'Oh oh!', 'You can select up to 15 categories. Want to select more? Let us Know!'
        this.props.openGeneralMessageModal('אוי לא!', 'ניתן לבחור עד 15 קטגוריות. רוצים לבחור עוד? דברו איתנו!');
    }

    deselectTypes(selectObj) {
        this.setState({ lookingForTypes: this.state.lookingForTypes.splice(this.state.lookingForTypes.indexOf(selectObj.name), 1)});
    }

    toggleAllTypes() {
        const optionList = this.props.type === BAND ? this.props.datatypes.categories.musician : this.props.datatypes.categories.band;

        if (this.state.lookingForTypes && this.state.lookingForTypes.length === optionList.length) {
            this.setState({ lookingForTypes: []});
            return;
        }

        const lookingForTypes = optionList.map(t => {
            return t.name
        });

        this.setState({ lookingForTypes });
    }

    selectSubCategory(subCategory) {
        let subCategories = this.state.subCategories || [];

        let subCategoryIndex = subCategories.indexOf(subCategory);
        if (subCategoryIndex>-1) {
            subCategories.splice(subCategoryIndex,1);

        } else {
            if (subCategories.length === 3) return;

            subCategories.push(subCategory);
        }

        console.log('selecting subCategory', subCategory);

        this.setState({subCategories});
    }

    selectPrices(event) {
        if (event.target.name === 'priceFinal') {
            this.setState({
                [event.target.name]: parseFloat(event.target.value),
                priceRangeMin: 0,
                priceRangeMax: 0,
            });

            return
        }

        this.setState({
            [event.target.name]: parseFloat(event.target.value),
            priceFinal: 0
        })
    }

    selectPricesByButton(priceType) {
        if (priceType === 'price') {

            this.setState({
                priceRangeMin: (this.props.editPinData && this.props.editPinData.prices && this.props.editPinData.prices.min) || 0,
                priceRangeMax: (this.props.editPinData && this.props.editPinData.prices && this.props.editPinData.prices.max) || 0,
                priceSelected: priceType
            });

            return;
        }

        if (priceType === 'free' || priceType === 'hat') {
            this.setState({
                priceRangeMin: (this.props.editPinData && this.props.editPinData.prices && this.props.editPinData.prices.min) || 0,
                priceRangeMax: (this.props.editPinData && this.props.editPinData.prices && this.props.editPinData.prices.max) || 0,
                priceFinal: (this.props.editPinData && this.props.editPinData.prices && this.props.editPinData.prices.price) || 0,
                priceSelected: priceType
            })
        }

        // this is for price-range
        this.setState({
            priceFinal: (this.props.editPinData && this.props.editPinData.prices && this.props.editPinData.prices.price) ||  0,
            priceSelected: priceType
        })
    }

    onDrop(files) {
        const newFiles = this.state.files || [];
        files.forEach((file)=>{
            if (newFiles.length + (this.state.images ? this.state.images.length : 0) < 5 ) {
                newFiles.push(file);
            }
        });

        this.setState({
            files: newFiles,
            uploadSuccess: files.length
        });
    }

    selectMainMediaImage(index, imageType) {
        if (this.state.images && imageType === 'uploaded') {
            const firstImage = this.state.images[index];
            const newImages = [...this.state.images];
            newImages.splice(index, 1);
            this.setState({images: [firstImage, ...newImages]});

            return;
        }

        if (this.state.files && imageType === 'new') {
            const firstFile = this.state.files[index];
            const newFiles = [...this.state.files];
            newFiles.splice(index, 1);
            this.setState({ files: [firstFile, ...newFiles] });
        }
    }

    removeImage(index, imageType) {
        // remove selected files - not uploaded yet
        if (this.state.files && imageType === 'new') {
            const files = [...this.state.files];
            files.splice(index, 1);
            this.setState({ files })

            return;
        }

        if (this.state.images && imageType === 'uploaded') {
            // remove uploaded images
            const images = [...this.state.images];
            images.splice(index, 1);
            this.setState({ images })
        }
    }

    checkRequired() {
        const required = ['name', 'iWeAre', 'lookingForTypes'];

        let userShouldEnter = [];
        required.forEach(field => {
            // Band finder can enter address without streets - living this here for now
            // check if location have a street in it
            // if (field === 'location' && this.state[field]) {
            //     if (!this.state[field].street) {
            //         userShouldEnter.push('Missing street name')
            //     }
            //
            //     return;
            // }

            if (this.state[field] === undefined || (this.state[field] &&  this.state[field].length === 0) || (this.state[field] === '')) {
                if (field === 'subCategories') {
                    userShouldEnter.push('Sub categories');

                    return;
                }

                userShouldEnter.push(field);
            }
        });

        // not contact info check
        if (!this.state.phone && !this.state.email && !this.state.fblink) {
            userShouldEnter.push('Phone/Email/FB Link');
        }

        this.setState({ userShouldEnter });
        return userShouldEnter;
    }

    checkValidation() {
        if (this.props.type === BAND) {
            if (this.state.email && !isEmailValid(this.state.email)) {
                // 'Email address is not valid'
                this.props.openGeneralMessageModal('אוי לא!', 'כתובת מייל אינה תקינה');

                // alert('Email address is not valid');

                return true;
            }

            // example to legit FB page: https://www.facebook.com/name.lastname
            // FB validation
            if ( this.state.fblink && !isFBPageUrlValid(this.state.fblink)) {
                this.props.openGeneralMessageModal('אוי לא!', 'הלינק של פייסבוק לא תקין');
                // alert('Facebook URL is not valid');

                return true;
            }
        }

        if (this.props.type === MUSICIAN) {
            if (this.state.phone && !isPhoneNumberValid(this.state.phone)) {
                this.props.openGeneralMessageModal('אוי לא!', 'מספר הטלפון אינו תקין');

                // alert('Phone number is not valid');

                return true
            }

            if (this.state.email && !isEmailValid(this.state.email)) {
                this.props.openGeneralMessageModal('אוי לא!', 'כתובת מייל אינה תקינה');

                // alert('Email address is not valid');

                return true;
            }

            if (this.state.priceFinal && (this.state.priceRangeMin || this.state.priceRangeMac)) {
                this.props.openGeneralMessageModal('אוי לא!', 'לא יכול להיות טווח מחירים ומחיר סופי ביחד');

                // alert('Cant have price range and final price together');

                return true;
            }

            if ((!this.state.priceRangeMin && this.state.priceRangeMax) || (this.state.priceRangeMin && !this.state.priceRangeMax)) {
                this.props.openGeneralMessageModal('אוי לא!', 'לא יכול להיות טווח מחירים ומחיר סופי ביחד');

                // alert('For price range you need set min and max prices');

                return true;
            }
        }
    }

    handleCloseModal() {
        this.props.closeModal();
    }


    selectCurrency(selectedCurrency) {
        this.setState({ selectedCurrency })
    }

    chooseCategory(category) {
        if (!this.props.editMode) {
            console.log('select category', category)
            this.setState({ category })
        }
    }

    goLive() {
        // Something went wrong, refresh page and try again
        if (!this.props.user) return alert('משהו השתבש, רענן את הדף ונסה שוב');

        // check if user is logged in and verified
        if (!this.props.token) {
            this.props.openSignupModal({
                signupTextType: 'member-notice'
            });
            return;
        }

        if (!this.props.user.isVerified) {
            this.props.setWarningMessage('אנא אשר את חשבונך', 'resendEmail');
            return;
        }

        const userShouldEnter = this.checkRequired();
        if (userShouldEnter.length > 0) {

            const displayList = userShouldEnter.map(l => {
                if (l === 'desc') {
                    l = 'description';
                }

                if (l === 'iWeAre') {
                    l = this.props.type === MUSICIAN ? 'I am a' : 'We are a'
                }

                if (l === 'lookingForTypes') {
                    l = 'Looking for';
                }

                return capitalize(l);
            });

            const translatedList = displayList.map(missingItem => translateMissingItem(missingItem));

            // alert('Those fields must be filled: ' + listMissing);
            this.props.openGeneralMessageModal('אוי לא!', 'חסרים כמה שדות: ', translatedList);

            return;
        }

        if (this.checkValidation()) return;

        let pinObject = {
            id: this.state._id,
            type: this.props.type,
            iWeAre: this.state.iWeAre.name || this.state.iWeAre,
            lookingForTypes: this.state.lookingForTypes,
            images: this.state.images,
            desc: this.state.desc,
            category: this.state.category,
            location: this.state.location,
            price: this.state.price || 0,
            prices: {
                currency: this.state.selectedCurrency,
                min: this.state.priceSelected === 'price-range' ? this.state.priceRangeMin : 0,
                max: this.state.priceSelected === 'price-range' ? this.state.priceRangeMax : 0,
                price: this.state.priceSelected === 'price' ? this.state.priceFinal : 0,
                priceType: this.state.priceSelected
            },
            name: this.state.name,
            contactInfo: this.state.contactInfo,
            email: this.state.email,
            phone: this.state.phone,
            fblink: this.state.fblink,
            date: this.state.date,
            time: this.state.time,
            subCategories: this.state.subCategories,
            video: this.state.video,
            video_embed: this.state.video ? youtube_parser(this.state.video) || vimeo_parser(this.state.video): null,
            ticketLink: makeLinkFromString(this.state.ticketLink),
            link1: makeLinkFromString(this.state.link1),
            link2: makeLinkFromString(this.state.link2)
        };

        // if this is update pin flow
        if (this.state._id) {
            this.props.openLoadingModal();
            this.props.getVimeoThumbnail(this.state.video)
                .then(thumbnailUrl => {
                    pinObject.video_thumbnail = thumbnailUrl;

                    this.props.savePin(this.props.token, pinObject, this.state.files);
                    this.props.getPinsCall(this.props.filters);
                    this.props.getMapPinsCall(this.props.filters)
                    this.setState({ submitted: true });
                })
                .catch(err => {
                    this.props.savePin(this.props.token, pinObject, this.state.files);
                    this.props.getPinsCall(this.props.filters);
                    this.props.getMapPinsCall(this.props.filters);
                    this.setState({ submitted: true });
                })
            // if this is new pin
        } else {
            this.props.getVimeoThumbnail(this.state.video)
                .then(thumbnailUrl => {
                    pinObject.video_thumbnail = thumbnailUrl;
                    this.props.submitWaitingLogin(pinObject, this.state.files);

                    // if user not logged in popup a login window
                    // if (!this.props.isLoggedIn) {
                    //     this.props.openSignupModal();
                    //     this.props.closeModal();
                    //     return;
                    // }

                    // If have an activate plan, submit the pin to server
                    // browserHistory.replace(this.props.route);
                    // this.props.openPayingMethodsModal();

                    browserHistory.push('/packages')
                    this.props.closeModal();

                    this.setState({submitted: true});
                })
                .catch(err => {
                    this.props.submitWaitingLogin(pinObject, this.state.files);

                    // if user not logged in popup a login window
                    // if (!this.props.isLoggedIn) {
                    //     this.props.openSignupModal();
                    //     this.props.closeModal();
                    //     return;
                    // }

                    // If have an activate plan, submit the pin to server
                    this.props.closeModal();
                    // browserHistory.replace(this.props.route);
                    // this.props.openPayingMethodsModal();

                    browserHistory.push('/packages')
                    this.props.closeModal();

                    this.setState({submitted: true});
                })
        }

        AnalyticsService.sendEvent(AnalyticsService.events.SUBMIT_AD, `${pinObject.type}_${pinObject.category}`, null, {
            pin_type: pinObject.type,
            pin_category: pinObject.category
        });
    }

    // Offer your skills to bands
    // Recruit "missing" band members
    renderTopTitle() {
        if (this.props.type === MUSICIAN) return 'הציעו את עצמכם ללהקות';
        if (this.props.type === BAND) return `גייסו את חברי הלהקה החסרים שלכם`;
        return '';
    }

    renderScrollContent() {
        return (
            <div className="content">
                <div className="top-header">
                    <div className="mainTitle">
                    </div>

                    <div className={`main-icon rtl ${this.props.type}`}>
                        <SVGInline className="main-icon" svg={scopWhiteTxtSVG} />
                    </div>
                    <div className={`background-dots-wrapper`}>
                        <SVGInline className="background-dots-icon rtl" svg={backgroundDotsSVG} />
                    </div>
                </div>

                <div className="we-are-wrapper">
                    <BandFinderTypePicker
                        pickerType={this.props.type}
                        onSelect={iWeAre => this.setState({ iWeAre })}
                        selected={this.state.iWeAre}
                        datatypes={this.props.datatypes}
                        {...this.state}
                    />
                </div>

                <BandFinderForm
                    updateLocation={this.updateLocation.bind(this)}
                    updateValue={this.updateValue.bind(this)}
                    formType={this.props.type}
                    {...this.state}
                />

                <div className="looking-for rtl">
                    <div className="looking-for-header">
                        מחפשים
                    </div>
                    <BandFinderSlider
                        datatypes={this.props.datatypes}
                        type={this.props.type || 'band'}
                        selected={this.state.lookingForTypes}
                        handleClickItem={selectedObj => this.handleCategoryClick(selectedObj)}
                    />
                </div>

                <ContactBandFinder
                    formType={this.props.type}
                    updateValue={(event) => this.updateValue(event)}
                    email={this.state.email}
                    phone={this.state.phone}
                    fblink={this.state.fblink}
                    desc={this.state.desc}
                    userShouldEnter={this.state.userShouldEnter}
                />

                <MediaBandFinderLinks
                    type={this.props.type}
                    updateValue={this.updateValue.bind(this)}
                    ticketLink={this.state.ticketLink}
                    video={this.state.video}
                    link1={this.state.link1}
                    onDrop={files => this.onDrop(files)}
                    uploadSuccess={this.state.uploadSuccess}
                    removeImage={(index, imageType) => this.removeImage(index, imageType)}
                    files={this.state.files}
                    uploadedImages={this.state.images}
                    isBandFinder={true}
                    selectMainImage={(index, imageType) => this.selectMainMediaImage(index, imageType)}
                />

                {this.state._id ?
                    <div className={"goLive " + this.props.type} onClick={()=>this.goLive()}>
                        Update!
                        <SVGInline svg={lightningSvg} width="25px" fill={this.props.type === 'band' ? '#F4F4F4' : '#08FCC9'}/>
                    </div>:
                    <div className={"goLive " + this.props.type} onClick={()=>this.goLive()}>
                        עלו לאויר!
                        <SVGInline svg={lightningSvg} width="25px" fill={this.props.type === 'band' ? '#F4F4F4' : '#08FCC9'}/>
                    </div>
                }
            </div>
        )
    }

    renderMobileScroll() {
        return (
            <div className="area">
                {this.renderScrollContent()}
            </div>
        )
    }

    renderWebScroll() {
        return (
            <ScrollArea
                speed={0.8}
                className="area"
                horizontal={false}
            >
                {this.renderScrollContent()}
            </ScrollArea>
        )
    }

    render() {
        return (
            <div className="submit">
                <Modal
                    isOpen={ this.props.isModalOpen}
                    contentLabel="Submit"
                    className="modal-wrapper submitModal submit-band-finder rtl"
                    onAfterOpen={this.updateLocationValue.bind(this)}
                    style={{overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0)'
                        }}}
                >
                    {/*<div className="closeButton" onClick={this.props.closeModal}>*/}
                        {/*X*/}
                    {/*</div>*/}
                    <div onClick={() => this.handleCloseModal()} >
                        <SVGInline className="close-btn" svg={closeCrossSVG} component="i"/>
                    </div>
                    <div className={"topTitle " + this.props.type}>
                        {this.renderTopTitle()}
                    </div>

                    {isMobile() ? this.renderMobileScroll() : this.renderWebScroll()}
                </Modal>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    message: state.users.signupMessage,
    type: state.users.submitType,
    token: state.users.token,
    isLoggedIn: state.users.isLoggedIn,
    editMode: state.users.editMode,
    editPinData: state.users.editPinData,
    filter: state.main.filters,
    pinDataWaiting: state.users.pinDataWaiting,
    datatypes: state.main.datatypes,
    programType: state.users.programType,
    user: state.users,
    route: state.routing.locationBeforeTransitions.pathname
});

SubmitBandFinderModal.propTypes = {
    type: PropTypes.string,
    closeModal: PropTypes.func,
    isModalOpen: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    savePin: PropTypes.func,
    getVimeoThumbnail: PropTypes.func,
    openLoadingModal: PropTypes.func,
    openPayingMethodsModal: PropTypes.func,
    programType: PropTypes.string,
    submitWaitingLogin: PropTypes.func,
    openSignupModal: PropTypes.func,
    getPinsCall: PropTypes.func,
    getMapPinsCall: PropTypes.func,
    token: PropTypes.string,
    user: PropTypes.object,
    datatypes: PropTypes.object,
    route: PropTypes.string,
    openGeneralMessageModal: PropTypes.func,
    setWarningMessage: PropTypes.func,
    getUserPins: PropTypes.func
};

// connecting redux state to the component props
export const SubmitBandFinderModalContainer = connect(mapStateToProps, {
    ...userActions,
    openPayingMethodsModal,
    openGeneralMessageModal,
    getPinsCall,
    getMapPinsCall,
    openLoadingModal,
    setWarningMessage
})(SubmitBandFinderModal);

export default SubmitBandFinderModal;



// WEBPACK FOOTER //
// ./src/Components/Users/SubmitBandFinderModal.js